import {
  ADMIN_PROFILE,
  ADMIN_USERS_LIST,
  ADMIN_USER_ADD,
  ADMIN_USER_CHANGE_STATUS,
  ADMIN_USER_DELETE,
  ADMIN_USER_EDIT,
  ADMIN_USER_GENERATE_QR,
  CHANGE_PASSWORD,
} from "../constants/api-path";
import httpClient from "./http.interceptor";

/**
 *
 * @returns User details
 */
export const getAdminProfile = (): Promise<any> => {
  return httpClient.get(ADMIN_PROFILE);
};

/**
 * @param {formData: FormData } params
 * @returns Promise<any>
 */
export const updateAdminProfile = (formData: FormData): Promise<any> => {
  return httpClient.post(ADMIN_PROFILE, formData);
};

/**
 * @param {page: number, limit: number, sortColumn: string|number, sortDirection: string } formData
 * @returns Promise<any>
 */
export const getAdminUsers = (formData: any): Promise<any> => {
  const params: any = {
    page: formData.page,
    pageSize: formData.limit,
    sort: formData.sort,
    search: formData.search,
    // Filters
    country_id: formData.country_id,
    province_id: formData.province_id,
    city_id: formData.city_id,
    store_id: formData.store_id,
    department_id: formData.department_id,
    role_id: formData.role_id,
    dropdown: formData.dropdown,
    for_update: formData.for_update,
  };
  if (formData.status && formData.status !== "-1") {
    params.status = formData.status;
  }
  return httpClient.get(ADMIN_USERS_LIST, { params });
};

/**
 * @param {formData: any } params
 * @returns Promise<any>
 */
export const addAdminUser = (formData: any): Promise<any> => {
  return httpClient.post(ADMIN_USER_ADD, formData);
};

/**
 * @param {id: string formData: any } params
 * @returns Promise<any>
 */
export const updateAdminUser = (id: string, formData: any): Promise<any> => {
  return httpClient.put(ADMIN_USER_EDIT + id, formData);
};

/**
 * @param {id: string } params
 * @returns Promise<any>
 */
export const deleteAdminUser = (id: string | number): Promise<any> => {
  return httpClient.delete(ADMIN_USER_DELETE + id);
};

/**
 * @param {formData: FormData } params
 * @returns Promise<any>
 */
export const changePassword = (formData: any): Promise<any> => {
  return httpClient.post(CHANGE_PASSWORD, formData);
};

/**
 * @param {formData: {status: string} } params
 * @returns Promise<any>
 */
export const changeStatus = (
  id: string | number,
  formData: any,
): Promise<any> => {
  // Backend defines status change as PATCH /v1/users/:id with body { status }
  return httpClient.patch(ADMIN_USER_EDIT + id, formData);
};

/**
 * @param {id: string }
 * @returns Promise<any>
 */
export const getAdminUserDetails = (id: string): Promise<any> => {
  return httpClient.get(ADMIN_USER_EDIT + id);
};

/**
 * @param {id: string | number }
 * @returns Promise<any>
 */
export const generateQR = (id: string | number): Promise<any> => {
  return httpClient.post(ADMIN_USER_GENERATE_QR + id);
};
